import { clsx } from 'clsx'
import type { HTMLAttributes, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react'

export function Table({ className, ...rest }: TableHTMLAttributes<HTMLTableElement>) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={clsx('w-full border-collapse text-small', className)} {...rest} />
    </div>
  )
}
export function Th({ className, ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return <th scope="col" className={clsx('border-b border-ink px-3 py-2 text-left text-[0.6875rem] font-medium uppercase tracking-eyebrow text-dim first:pl-0 last:pr-0', className)} {...rest} />
}
export function Td({ className, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={clsx('border-b border-gray-200 px-3 py-3 align-top first:pl-0 last:pr-0', className)} {...rest} />
}
export function Tr({ className, ...rest }: HTMLAttributes<HTMLTableRowElement>) {
  return <tr className={clsx('hover:bg-gray-50', className)} {...rest} />
}
